import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Loading from 'shared/components/Loading';
import { useAuth0Session } from 'shared/store/modules/auth/hooks';

export const LoginDispatch = () => {
  const { automaticDispatchToRoute, isAuthenticated, error } = useAuth0Session();

  useEffect(() => {
    if (isAuthenticated && !error) {
      automaticDispatchToRoute();
    }
    // eslint-disable-next-line
  }, [isAuthenticated, error]);

  if (error) {
    console.error(error);

    // @ts-ignore
    return <Navigate to={`/login?error=${error.message}&error_type=${error.error}`} replace />;
  }

  return <Loading />;
};
